import React, { useState, useEffect } from 'react';
import { Skeleton, Typography } from '@mui/material';
import { getDoc } from 'firebase/firestore';

const ViewCustomer = ({ customerRef }) => {
  const [customerData, setCustomerData] = useState(null);
  // const supplierDocRef = doc(db, 'suppliers', supplierId);
  // const supplierDocRef = getDoc(supplierRef);
  // const [supplierData, loading] = useDocumentData(supplierRef ?? null);
  useEffect(() => {
    // console.log(customerRef);
    const fetchCustomer = async () => {
      const customerSnap = await getDoc(customerRef);
      // console.log(customerSnap.data());
      if (customerSnap.exists()) {
        setCustomerData(customerSnap.data());
      }
    };
    if (customerRef.id) {
      fetchCustomer().then();
    }
  }, [customerRef]);
  if (!customerData && customerRef.id)
    return (
      <>
        <Skeleton
          variant={'text'}
          height={24}
          animation={'wave'}
        />
        <Skeleton
          variant={'text'}
          height={20}
          animation={'wave'}
        />
      </>
    );
  if (customerData)
    return (
      <>
        <Typography component={'div'}>
          {customerData.surname} {customerData.name}
        </Typography>
        <Typography
          color={'textSecondary'}
          variant={'body2'}
          component={'div'}
        >
          {customerData.phone}
        </Typography>
      </>
    );
};

export default ViewCustomer;
